module.exports = __webpack_public_path__ + "static/img/22.9e85cdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/skinAnalysis/22.png
// module id = JEXX
// module chunks = 1